import React from 'react';
import PropTypes from 'prop-types';
import { css } from 'emotion';

const wrapperStyle = css`
  display: inline-block;
  width: 100%;
  height: calc(100% - 48px);
  overflow: auto;
  position: relative;
  top: -8px;
  -webkit-overflow-scrolling: touch;
`;

const DrawerContent = ({ children }) => (
  <div className={wrapperStyle}>{children}</div>
);

DrawerContent.defaultProps = {
  children: null,
};

DrawerContent.propTypes = {
  children: PropTypes.node,
};

export default DrawerContent;
